import { createSelector } from 'reselect';
var recoverableUIStateSelector = function recoverableUIStateSelector(state) {
  return state.customercare.recoverableUiState.discount;
};
export var DiscountFormSelector = createSelector([recoverableUIStateSelector], function (uiState) {
  return uiState.discountForm;
});